"use strict";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
export const useTabsContent = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  return [
    {
      title: t("common.swap"),
      href: "/swap",
      isActive: pathname === "/swap"
    },
    {
      title: t("common.tokens"),
      href: "/explore/tokens",
      isActive: pathname.startsWith("/explore/tokens")
    },
    {
      title: t("common.pools"),
      href: "/explore/pools",
      isActive: pathname.startsWith("/explore/pools")
    },
    // {
    //   title: t('common.explore'),
    //   href: '/explore',
    //   isActive: pathname.startsWith('/explore') || pathname.startsWith('/nfts'),
    //   items: [
    //     { label: t('common.tokens'), href: '/explore/tokens', internal: true },
    //     // Go to Base pools by default
    //     { label: t('common.pools'), href: '/explore/pools/base', internal: true },
    //     // {
    //     //   label: t('common.transactions'),
    //     //   href: '/explore/transactions',
    //     //   internal: true,
    //     // },
    //   ],
    // },
    {
      title: "Deposit",
      href: "/positions/create",
      isActive: pathname.startsWith("/positions/create")
    },
    {
      title: "Dashboard",
      href: "/positions",
      isActive: pathname.startsWith("/positions")
    }
    // {
    //   title: t('common.pool'),
    //   href: '/positions',
    //   isActive: pathname.startsWith('/positions'),
    //   items: [
    //     {
    //       label: t('nav.tabs.viewPositions'),
    //       href: '/positions',
    //       internal: true,
    //     },
    //     {
    //       label: t('nav.tabs.createPosition'),
    //       href: '/positions/create',
    //       internal: true,
    //     },
    //   ],
    // },
  ];
};
